<div class="position-relative">

  <!-- SELECTED ITEM CARD -->
  <div
    class="context-card rounded-3 p-2 bg-collapsable-btn"
    style="cursor: pointer;"
    @click="toggle"
  >
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <div class="d-flex align-items-center gap-2">
          <i v-if="icon" :class="icon"></i>
          <p class="mb-0 text-white text-xs mb-1">{{ main_label }}</p>
        </div>

      </div>

      <i :class="open ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
    </div>
  </div>

  <!-- DROPDOWN PANEL -->
  <div
    v-if="open"
    class="context-dropdown position-absolute bg-collapsable-btn border border-dark border-2 rounded-3 p-3 dropdown-panel justify-content-center align-items-center"
  >
    <!-- OPTIONAL TOP SECTION (slot) -->
    <slot name="top"></slot>

    <!-- PROGRAMMES LIST -->
    <div class="dropdown-scroll overflow-auto">
      <div
        v-for="programme in programmes"
        :key="programme.id"
        class="py-1 d-flex justify-content-between align-items-center text-xs"
        style="cursor: pointer;"
        @click="navigateToProgramme(programme)"
      >
        <!-- Programme Label -->
        <div class="d-flex align-items-center gap-2">
          <small class="d-block mb-0 text-white">
            {{ programme.name }}
          </small>
        </div>

        <!-- Optional active dot (only if you have an active check) -->
        <span v-if="isActiveProgramme(programme)" class="active-dot"></span>
      </div>
    </div>
  </div>

</div>
